import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Orders } from '@/pages/orders';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { documentsSearchSchema } from '@/routes/protected/_layout/documents/_layout';

export const Route = createFileRoute('/protected/_layout/orders/_layout')({
  validateSearch: documentsSearchSchema,
  component: OrdersLayout,
});

function OrdersLayout() {
  const { canAccessOrders, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessOrders} isLoading={isLoading}>
      <Orders />
      <Outlet />
    </RoleGuard>
  );
}
